
import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

interface RelevanceInputProps {
  onSubmit?: (relevanceContext: string) => void;
  isLoading?: boolean;
  relevanceContext: string;
  setRelevanceContext: (value: string) => void;
  onRelevanceSubmit?: (context: string) => Promise<void>;
}

const RelevanceInput = ({
  onSubmit,
  isLoading = false,
  relevanceContext,
  setRelevanceContext,
  onRelevanceSubmit
}: RelevanceInputProps) => {
  const handleSubmit = () => {
    if (relevanceContext.trim().length < 10) {
      toast.error("Please provide more context about relevance criteria");
      return;
    }
    
    // Use onRelevanceSubmit if provided, otherwise fall back to onSubmit
    if (onRelevanceSubmit) {
      onRelevanceSubmit(relevanceContext);
    } else if (onSubmit) {
      onSubmit(relevanceContext);
    }
    
    toast.success("Relevance criteria updated and saved");
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Relevance Criteria</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Textarea 
          placeholder="Enter keywords, technology areas, business models, or other criteria to help evaluate investor relevance..."
          className="min-h-[120px]"
          value={relevanceContext}
          onChange={(e) => setRelevanceContext(e.target.value)}
        />
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
          className="w-full"
        >
          {isLoading ? "Updating..." : "Update Relevance Criteria"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default RelevanceInput;
